import { useParams } from "react-router-dom"

import {
  ActivityLogContext,
  ActivityLogProvider,
} from "domain/activityLog/ActivityLogContext"
import { activityLogSelectors } from "domain/activityLog/selectors"
import { GridContainer } from "domain/core/containers/GridContainer"
import { dataToRow } from "domain/activityLog/mappers"

import { columnConfig } from "./columns.config"

export const ChangesLogList = () => {
  const { name } = useParams()

  const activityInitParams = {
    filters: {
      objectId: name,
      objectType: ["partner-customization"],
    },
    sort: [],
  }

  return (
    <ActivityLogProvider>
      <GridContainer
        url="/v1/events/list"
        context={ActivityLogContext}
        selectors={activityLogSelectors}
        columns={columnConfig}
        dataToRow={dataToRow}
        initParams={activityInitParams}
        rowHeight={48}
        themeOverride={{
          components: {
            MuiDataGrid: {
              styleOverrides: {
                row: {
                  "&:hover": {
                    background: "none",

                    "&:before": {
                      content: `""`,
                    },
                  },
                },
              },
            },
          },
        }}
      />
    </ActivityLogProvider>
  )
}
